const VISIBILITY_VALUES = new Set(['ASSIGNED_ONLY', 'ALL_MEMBERS'])

export function mayAssignResource(context) {
	const membership = context?.membership
	return membership?.status === 'ACTIVE' && ['OWNER', 'ADMIN'].includes(membership.role)
}

export function activeAssignmentTargets(profile) {
	if (!Array.isArray(profile?.memberships)) return []
	return profile.memberships
		.filter(membership => membership?.status === 'ACTIVE')
		.map(membership => Object.freeze({
			id: String(membership.id),
			label: membership.title
				? `${membership.displayName || 'Профессиональный профиль'} — ${membership.title}`
				: membership.displayName || 'Профессиональный профиль',
			role: membership.role,
		}))
}

export function normalizeVisibilityPolicy(value) {
	if (!VISIBILITY_VALUES.has(value)) throw new TypeError('Invalid visibility policy')
	return value
}

export function visibilityLabel(value) {
	return value === 'ALL_MEMBERS' ? 'Все активные участники' : 'Только назначенный участник'
}
